module.exports = __webpack_public_path__ + "static/media/Recency Effect - kyrie-kim-jqxB3C0YNG0-unsplash.0ea5b8f6.jpg";